<p-tabs value="users" [value]="initialSegment()">
  <p-tablist>
    <p-tab value="users" [routerLink]="['users']">Users</p-tab>
    <p-tab value="new-users" [routerLink]="['new-users']">Users V2</p-tab>
    <p-tab value="emails" [routerLink]="['emails']">Emails</p-tab>
    <p-tab value="apartments" [routerLink]="['apartments']">Apartments</p-tab>
    <p-tab value="failed-applications" [routerLink]="['failed-applications']">Failed Applications</p-tab>
    <p-tab value="delayed-applications" [routerLink]="['delayed-applications']">Delayed Applications</p-tab>
    <p-tab value="cancels" [routerLink]="['cancels']">Cancels</p-tab>
    <p-tab value="exports" [routerLink]="['exports']">Exports</p-tab>
    @if (manualCheckEnabled) {
      <p-tab value="notification-check" [routerLink]="['notification-check']">Notification check</p-tab>
    }
  </p-tablist>
</p-tabs>
<router-outlet/>
